export default "__VITE_ASSET__JKM7z2xG__"